// extracted by mini-css-extract-plugin
export default {"image":"responsecard_image__E68JW"};